module.exports = __webpack_public_path__ + "static/media/share.b1caa841.svg";